







import Vue from 'vue'
export default Vue.extend({
  name: 'ReloadItem',
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
})
